import { useNavigate } from 'react-router-dom';
import { useApp } from '@/contexts/AppContext';
import { SidebarTrigger } from '@/components/ui/sidebar';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Building2, Zap } from 'lucide-react';
import { NotificationBell } from '@/components/notifications/NotificationBell';

export function AppHeader() {
  const navigate = useNavigate();
  const {
    properties,
    plants,
    selectedPropertyId,
    selectedPlantId,
    selectProperty,
    selectPlant,
    setPropertyScope,
  } = useApp();

  const propertyPlants = plants.filter(p => p.property_id === selectedPropertyId);
  const selectedProperty = properties.find(p => p.id === selectedPropertyId);
  const selectedPlant = plants.find(p => p.id === selectedPlantId);

  const handlePropertyChange = (propertyId: string) => {
    const property = properties.find(p => p.id === propertyId);
    selectProperty(propertyId);
    setPropertyScope(propertyId, property?.name ?? 'Property');
    navigate(`/app/property/${propertyId}`);
  };

  return (
    <header className="sticky top-0 z-40 flex h-14 items-center gap-4 border-b border-border bg-wt-bg-primary/95 text-foreground backdrop-blur supports-[backdrop-filter]:bg-wt-bg-primary/60 px-4">
      <SidebarTrigger className="-ml-1 hidden md:flex" aria-label="Open menu" />
      
      <div className="flex-1" />

      <div className="flex items-center gap-3">
        {/* Notification Bell */}
        <NotificationBell />

        {/* Property Selector */}
        {properties.length > 0 && (
          <Select value={selectedPropertyId ?? ''} onValueChange={handlePropertyChange}>
            <SelectTrigger className="w-[180px] bg-wt-bg-secondary">
              <Building2 className="h-4 w-4 mr-2 text-muted-foreground" />
              <SelectValue placeholder="Select property" />
            </SelectTrigger>
            <SelectContent>
              {properties.map((property) => (
                <SelectItem key={property.id} value={property.id}>
                  {property.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        )}

        {/* Plant Selector (only show if multiple plants) */}
        {propertyPlants.length > 1 && (
          <Select value={selectedPlantId ?? ''} onValueChange={selectPlant}>
            <SelectTrigger className="w-[160px] bg-wt-bg-secondary">
              <Zap className="h-4 w-4 mr-2 text-muted-foreground" />
              <SelectValue placeholder="Select plant" />
            </SelectTrigger>
            <SelectContent>
              {propertyPlants.map((plant) => (
                <SelectItem key={plant.id} value={plant.id}>
                  {plant.display_name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        )}
        {/* Mobile: hamburger on right to open sidebar (Sign Out, nav) */}
        <SidebarTrigger className="md:hidden ml-1" aria-label="Open menu" />
      </div>
    </header>
  );
}
